<section>
        {{currencySymbol}}<span class="leading-zero">{{leadingZeroes}}</span>{{significantDigits}}
</section>